class UserProfileService {
    constructor() {
        this.baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    }

    // User Profile Management
    async getUserProfile(walletAddress) {
        try {
            const response = await fetch(`${this.baseUrl}/user/${walletAddress}`);
            if (!response.ok) throw new Error('Failed to fetch user profile');
            return await response.json();
        } catch (error) {
            console.error('Failed to fetch user profile:', error);
            throw error;
        }
    }

    async updateUserProfile(walletAddress, profileData) {
        try {
            const response = await fetch(`${this.baseUrl}/user/${walletAddress}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(profileData),
            });
            if (!response.ok) throw new Error('Failed to update user profile');
            return await response.json();
        } catch (error) {
            console.error('Failed to update user profile:', error);
            throw error;
        }
    }

    // Social Connections
    async connectSocial(walletAddress, platform, socialData) {
        try {
            const response = await fetch(`${this.baseUrl}/user/${walletAddress}/social/${platform}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(socialData),
            });
            if (!response.ok) throw new Error(`Failed to connect ${platform}`);
            return await response.json();
        } catch (error) {
            console.error(`Failed to connect ${platform}:`, error);
            throw error;
        }
    }

    async disconnectSocial(walletAddress, platform) {
        try {
            const response = await fetch(`${this.baseUrl}/user/${walletAddress}/social/${platform}`, {
                method: 'DELETE',
            });
            if (!response.ok) throw new Error(`Failed to disconnect ${platform}`);
            return await response.json();
        } catch (error) {
            console.error(`Failed to disconnect ${platform}:`, error);
            throw error;
        }
    }

    // Presale Stats
    async getPresaleStats(walletAddress) {
        try {
            const response = await fetch(`${this.baseUrl}/user/${walletAddress}/presale`);
            if (!response.ok) throw new Error('Failed to fetch presale stats');
            return await response.json();
        } catch (error) {
            console.error('Failed to fetch presale stats:', error);
            throw error;
        }
    }

    // Quest Progress
    async getQuestProgress(walletAddress) {
        try {
            const response = await fetch(`${this.baseUrl}/user/${walletAddress}/quests`);
            if (!response.ok) throw new Error('Failed to fetch quest progress');
            return await response.json();
        } catch (error) {
            console.error('Failed to fetch quest progress:', error);
            throw error;
        }
    }

    async updateQuestProgress(walletAddress, questId, progress) {
        try {
            const response = await fetch(`${this.baseUrl}/user/${walletAddress}/quests/${questId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ progress }),
            });
            if (!response.ok) throw new Error('Failed to update quest progress');
            return await response.json();
        } catch (error) {
            console.error('Failed to update quest progress:', error);
            throw error;
        }
    }

    // Referral System
    async getReferralStats(walletAddress) {
        try {
            const response = await fetch(`${this.baseUrl}/user/${walletAddress}/referrals`);
            if (!response.ok) throw new Error('Failed to fetch referral stats');
            return await response.json();
        } catch (error) {
            console.error('Failed to fetch referral stats:', error);
            throw error;
        }
    }

    async createReferralCode(walletAddress) {
        try {
            const response = await fetch(`${this.baseUrl}/user/${walletAddress}/referrals/code`, {
                method: 'POST',
            });
            if (!response.ok) throw new Error('Failed to create referral code');
            return await response.json();
        } catch (error) {
            console.error('Failed to create referral code:', error);
            throw error;
        }
    }
}

export default new UserProfileService();
